var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidXMarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM8.33033 8.33033C8.67685 7.9838 9.23867 7.9838 9.58519 8.33033L12 10.7451L14.4148 8.33033C14.7614 7.9838 15.3232 7.9838 15.6697 8.33033C16.0162 8.67685 16.0162 9.23867 15.6697 9.58519L13.2549 12L15.6697 14.4148C16.0162 14.7614 16.0162 15.3232 15.6697 15.6697C15.3232 16.0162 14.7614 16.0162 14.4148 15.6697L12 13.2549L9.58519 15.6697C9.23867 16.0162 8.67685 16.0162 8.33033 15.6697C7.9838 15.3232 7.9838 14.7614 8.33033 14.4148L10.7451 12L8.33033 9.58519C7.9838 9.23867 7.9838 8.67685 8.33033 8.33033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidXMarkCircle);
export default __webpack_public_path__ + "static/media/solid-x-mark-circle.75400e2bcbd30cf6242afc7d3fc3dfe0.svg";
export { ForwardRef as ReactComponent };